module.exports = __webpack_public_path__ + "img/img-5180d7.png";